import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { removeUserFob, fetchUserFobs } from "actions/Users";
import TableNew from "components/TableNew";
import Icon from "components/Icon";
import ButtonContained from "components/ButtonContained";

const UserSettingsFobsModal = () => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const authUser = useSelector(state => state.auth.authUser);
  const user = useSelector(state => state.users.userObject);
  const userFobs = useSelector(state => state.users.userFobs);
  const [selectedFob, setSelectedFob] = useState(null);

  useEffect(() => {
    if (user) {
      dispatch(fetchUserFobs(user.uuid));
    }
  }, [user]);

  useEffect(() => {
    if (userFobs && userFobs.length > 0) {
      setSelectedFob(userFobs[0]);
    } else {
      setSelectedFob(null);
    }
  }, [userFobs]);

  const preSelectedRows = userFobs && userFobs.length > 0 ? [userFobs[0].uuid] : [];

  return (
    <div className="min-h-[300px] px-10 pt-4 flex flex-col">
      <div className="grid grid-cols-2 gap-8">
        <div>
          <h5 className="tw-heading-5">{intl.formatMessage({ id: "pages.fobs.Types" })}</h5>
          <TableNew
            data={userFobs || []}
            defaultSortKey="name"
            singleSelect={true}
            onSelectionChange={(selected) => selected.length !== 0 && selected[0] !== selectedFob.uuid && setSelectedFob(userFobs.find(fob => fob.uuid === selected[0]))}
            preSelectedRows={preSelectedRows}
            noPadding={true}
            columns={[
              {
                key: "name",
                label: intl.formatMessage({ id: "comp.table.header.name" }),
                sortable: true,
                render: (e) => (
                  <div className="flex flex-col gap-1 pl-4">
                    <span className="tw-desc-reg color-[var(--color-gray-800)] font-semibold capitalize">{e.name}</span>
                    <span className="tw-paragraph-sm color-[var(--color-gray-800)]">{e.mac}</span>
                  </div>
                ),
              },
              {
                key: "uuid",
                label: "",
                sortable: false,
                align: "justify-end",
                render: () => (
                  <div className="pr-4">
                    <Icon name="arrowRight" size={16} className="text-[var(--color-gray-400)]" />
                  </div>
                )
              }
            ]}
          />
        </div>
        {selectedFob && <div className="flex flex-col gap-4">
          <h5 className="tw-heading-5 mb-4">{intl.formatMessage({ id: "pages.fobs.details" })}</h5>
          <div className="flex flex-col gap-1">
            <span className="tw-desc-reg color-[var(--color-gray-800)] font-semibold">{intl.formatMessage({ id: "form.name" })}</span>
            <span className="tw-paragraph-sm color-[var(--color-gray-800)] capitalize">{selectedFob?.name}</span>
          </div>
          <div className="flex flex-col gap-1">
            <span className="tw-desc-reg color-[var(--color-gray-800)] font-semibold">{intl.formatMessage({ id: "form.mac" })}</span>
            <span className="tw-paragraph-sm color-[var(--color-gray-800)] capitalize">{selectedFob?.mac}</span>
          </div>
          <div className="flex flex-col gap-1">
            <span className="tw-desc-reg color-[var(--color-gray-800)] font-semibold">{intl.formatMessage({ id: "form.battery" })}</span>
            <span className="tw-paragraph-sm color-[var(--color-gray-800)] capitalize">{selectedFob?.battery}</span>
          </div>
          <div className="flex flex-col gap-1 mb-4">
            <span className="tw-desc-reg color-[var(--color-gray-800)] font-semibold">{intl.formatMessage({ id: "form.sync" })}</span>
            <span className="tw-paragraph-sm color-[var(--color-gray-800)] capitalize">{intl.formatMessage({ id: `db.${selectedFob.syncFlag}` })}</span>
          </div>
          {authUser?.permissions?.includes("fob_remove_user") && <ButtonContained
            id="User-Settings-Remove-Fob-Button"
            dataCy="User-Settings-Remove-Fob-Button"
            text={intl.formatMessage({ id: "comp.button.remove.fob" })}
            type="medium"
            overrideColor="bg-[var(--color-alert)]"
            onClick={() => dispatch(removeUserFob(selectedFob.uuid, user.uuid, false, { successMessage: intl.formatMessage({ id: "notifications.success.edit" }), refetchFobs: true }))}
          />}
        </div>}
      </div>
    </div>
  )
};

export default UserSettingsFobsModal;
